<template lang="pug">
span &nbsp;
</template>

<script>
export default {
  name: 'DashboardLogout',
  mounted() {
    localStorage.removeItem(window.PREFIX + "token")
    localStorage.removeItem(window.PREFIX + "type")
    this.$store.commit('set_token', null)
    this.$store.commit('set_type', null)
    this.$router.push({
      name: 'Root',
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardLogout.vue